<!-- src/components/VueTablePagination.vue -->

<template>
    <div class="table-pagination flex flex-row items-center justify-end p-2.5" v-if="totalPages > 1">
        <a class="table-pagination-prev"
            @click="previousPage()"
            v-if="currentPage > 1">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
        </a>
<!--        <a @click="selectPage(1)"-->
<!--            :class="{ selected: currentPage === 1 }">1</a>-->
<!--        <span v-if="currentPage > 2">...</span>-->
<!--        <a v-if="currentPage > 2 && currentPage === totalPages && totalPages < 3"-->
<!--            @click="selectPage(currentPage - 2)">{{ currentPage - 2 }}</a>-->
<!--        <a v-if="currentPage > 2"-->
<!--            @click="selectPage(currentPage - 1)">{{ (currentPage - 1) }}</a>-->
<!--        <a v-if="currentPage !== 1 && currentPage !== totalPages"-->
<!--            @click="selectPage(currentPage)"-->
<!--            class="selected">{{ currentPage }}</a>-->
<!--        <a v-if="currentPage < totalPages - 1"-->
<!--            @click="selectPage(currentPage + 1)">{{ currentPage + 1 }}</a>-->
<!--        <a v-if="currentPage < totalPages - 1 && currentPage === 1 && totalPages > 3"-->
<!--            @click="selectPage(currentPage + 2)">{{ currentPage + 2 }}</a>-->
<!--        <span v-if="currentPage < totalPages - 1">...</span>-->
<!--        <a @click="selectPage(totalPages)"-->
<!--            :class="{ selected: currentPage === totalPages }">{{ totalPages }}</a>-->
        <a class="table-pagination-next"
            @click="nextPage()"
            v-if="currentPage < totalPages">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>

        </a>
        <div class="table-pagination-quick-page">
            <select class="border rounded-sm text-base" v-model="tempCurrentPage" @change="selectPage(tempCurrentPage)">
                <option v-for="n in totalPages" :value="n">{{ n }}</option>
            </select>
        </div>
    </div>
</template>

<script>

export default {

    props: {
        totalRows: {
            default: 0
        },
        perPage: {
            type: Number,
            default: 15
        },
        currentPage: {
            type: Number,
            default: 1
        }
    },

    data: function() {
        return {
            tempCurrentPage: this.currentPage
        }
    },

    computed: {
        totalPages () {
            if (this.totalRows <= 0) {
                return 0;
            }
            return Math.ceil(this.totalRows / this.perPage);
        },

        previousPages () {
            var pages = [];
            for (var i = this.currentPage - 1; i > 1; i--) {
                if (pages.length < 2) {
                    pages.push(i);
                }
            }

            if (this.currentPage != 1) {
                pages.push(1);
            }

            return pages.reverse();
        },

        nextPages () {
            var pages = [];
            for (var i = this.currentPage + 1; i < this.totalPages; i++) {
                if (pages.length < 2) {
                    pages.push(i);
                }
            }

            if (this.currentPage < this.totalPages) {
                pages.push(this.totalPages);
            }

            return pages;
        }
    },

    methods: {
        selectPage (page) {
            if (page <= 0) {
                page = 1;
            }
          this.$emit("selected-page", page);
        },

        previousPage () {
            if (this.currentPage > 1) {
                this.selectPage(this.currentPage - 1);
            }
        },

        nextPage () {
            if (this.currentPage < this.totalPages) {
                this.selectPage(this.currentPage + 1);
            }
        }
    }
}
</script>

<style>
.table-pagination a {
    padding: 3px 7px;
    display: inline-block;
    font-family: var(--font-family);
    font-weight: 500;
    font-size: 12px;
    color: #969696;
    letter-spacing: 0;
    margin: 2px;
    cursor: pointer;
}

.table-pagination span {
    font-size: 12px;
    display: inline-block;
    padding: 3px;
}

.table-pagination a.selected,
.table-pagination a:hover {
    background: var(--primary-color1);
    margin: 2px;
    color: #FFF;
}
</style>
